export default __webpack_public_path__ + "bd90c13976dfe4e512bfe05720ecd63c.jpg";